import React from 'react'
import { Button } from 'antd'
import { FormOutlined } from '@ant-design/icons'

export const ADP_MARKETPLACE_URL = 'https://apps.adp.com/en-US/apps/727363/vacation-tracker-connector-for-adp-workforce-now/'

export const goToADPMarketplace = () => {
  window.open(ADP_MARKETPLACE_URL, '_blank')
}

export const ADPMarketplaceBtn = () => {
  return (
    <Button size="large" type="link" href={ADP_MARKETPLACE_URL} target="_blank" rel="noopener noreferrer">
      ADP Marketplace <FormOutlined />
    </Button>
  )
}
